// extracted by mini-css-extract-plugin
export default {"center":"OrderError-center_jJBUu"};